import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  TextField,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  Checkbox,
  FormControlLabel,
  Modal,
  Divider,
  Tooltip,
  InputAdornment,
  Radio,
  Autocomplete,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import Loader from '../../../Components/Loader';
import { ImagePaths } from "../../../Utility/ImagePaths";
import { CommonPatientDetails } from "../../../Components/Common Components/CommonComponents";
import { AmountFormat, ContentInTooltip } from "../../../Components/CommonFunctions/CommonFunctions";
import { Colors } from "../../../Styles/Colors";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";
import { CurrencySymbol, TXN_MSG_MAX, TXN_MSG_MAX_LEN } from "../../../Utility/Constants";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { set } from "date-fns";
import { localGetItem, setCachevalue } from "../../../Utility/Services/CacheProviderService";


const MembershipPayment = (props) => {
  const history = useHistory();
  const location = useLocation();
  const [UhidOrPhNumber, setUhidOrPhNumber] = useState('');
  const [isErrorMsg, setIsErrorMsg] = useState(false);
  const [isErrorMsgText, setIsErrorMsgText] = useState('');
  const [successMsg, setSuccessMsg] = useState(false);
  const [successMsgText, setSuccessMsgText] = useState('');
  const [isLoader, setIsLoader] = useState(false);
  const [PatientSearchList, setPatientSearchList] = useState([]);
  const [triggerSignal, setTriggerSignal] = useState(false);
  const [MembershipNumber, setMembershipNumber] = useState("");
  const [MemberSummaryId, setMembersummaryId] = useState(null);
  const [MemberReceiptId, setMemberReceiptId] = useState(null);
  const [MembersList, setMembersList] = useState([]);
  const [packageList, setPackageList] = useState([]);
  const [DeletedIds, setDeletedIds] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [primaryPatientId, setPrimaryPatientId] = useState(null);
  const [isCardEdit, setIsCardEdit] = useState(false);
  const [payments, setPayments] = useState({
    isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
    cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
    upi_no: '', cheque_amt: '', cheque_no: '',
  });

  useEffect(() => {
    getPackagesList(true)

  }, []);

  const errorMessage = (message) => {
    setIsLoader(false)
    setIsErrorMsgText(message);
    setIsErrorMsg(true);
  };

  const successMessage = (message) => {
    setIsLoader(false)
    setSuccessMsgText(message);
    setSuccessMsg(true);
  };

  const LoaderFunction = (key) => {
    setIsLoader(key);
  };

  const getMembershipData = (PackData = []) => {
    try {
      setIsLoader(true)
      let Data = location.states?.PackageData || {}
      RestAPIService.getAll(Serviceurls.MEMBERSHIP_MEMBER_ADD + `?membership_card_id=${Data?.membership_card_id || ''}`)
        .then((response) => {
          if (response.data.status === 'success') {
            setIsLoader(false)
            setIsCardEdit(true)
            setSelectedPackage(PackData?.find((pack) => pack?.id === Data?.package_id) || null)
            setMembersList(response.data.data || [])
            setPrimaryPatientId(response.data.data?.find((list) => list?.is_primary_patient)?.patient_id || null)
          }
        }).catch(e => {
          setIsLoader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getPackagesList = (FromFirst = false) => {
    try {
      setIsLoader(true)
      RestAPIService.getAll(Serviceurls.MEMBERSHIP_PACKAGE_CONFIG)
        .then((response) => {
          if (response.data.status === 'success') {
            let List = []
            response.data.data?.forEach((element) => {
              List.push({
                ...element,
                sno: List.length + 1,
                duration_str: element?.duration + " " + element?.duration_mode,
                percentages: (() => {
                  let Percents = [];

                  if (element?.discount_percentage_details) {
                    const details = element.discount_percentage_details;

                    // fixed order
                    if (details?.OP_details?.length) {
                      const percent = details.OP_details[0]?.discount_percentage || 0;
                      if (percent) Percents.push(`OP - ${percent}%`);
                    }

                    if (details?.IP_details?.length) {
                      const percent = details.IP_details[0]?.discount_percentage || 0;
                      if (percent) Percents.push(`IP - ${percent}%`);
                    }

                    if (details?.Lab?.discount_percentage) {
                      Percents.push(`Lab - ${details.Lab.discount_percentage}%`);
                    }

                    if (details?.Pharmacy?.discount_percentage) {
                      Percents.push(`Pharmacy - ${details.Pharmacy.discount_percentage}%`);
                    }

                    if (details?.Radiology?.discount_percentage) {
                      Percents.push(`Radiology - ${details.Radiology.discount_percentage}%`);
                    }

                    if (details?.OT?.discount_percentage) {
                      Percents.push(`OT - ${details.OT.discount_percentage}%`);
                    }

                    // dynamic keys (other than fixed ones)
                    Object.keys(details).forEach((key) => {
                      if (!["OP_details", "IP_details", "Lab", "Pharmacy", "Radiology", "OT"].includes(key)) {
                        let percent = 0;
                        if (Array.isArray(details[key])) {
                          percent = details[key]?.[0]?.discount_percentage || 0;
                        } else {
                          percent = details[key]?.discount_percentage || 0;
                        }
                        if (percent) {
                          const label = key.replace("_details", ""); // clean name if needed
                          Percents.push(`${label} - ${percent}%`);
                        }
                      }
                    });
                  }
                  return Percents;
                })(),
              });
            })
            setPackageList(List)
            setIsLoader(false)
            if (FromFirst) {
              if (location.states?.PackageData) {
                getMembershipData(List)
              }
            }

          }
        }).catch(e => {
          setIsLoader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getPatientDataSearch = (patient_data = "") => {
    try {
      LoaderFunction(true);
      RestAPIService.getAll(Serviceurls.NEW_BILLING_PATIENT_SEARCH + '?search_key=' + patient_data)
        .then((response) => {
          if (response.data.status === 'success') {
            const list = response.data.data || [];
            LoaderFunction(false);
            if (list?.length) {
              let data = list?.length === 1 ? list[0] : {}
              setUhidOrPhNumber("");
              setTriggerSignal(!triggerSignal);
              if (list?.length === 1) {
                let patientFullName = `${data.first_name} ${data.last_name}`;
                const patientData = {
                  ...data,
                  patient_name: patientFullName,
                  patient_mobile_number: data.mobile_number,
                  patient_photo_url: data.photo_url
                };
                if (MembersList?.every((member) => member?.patient_id !== patientData?.patient_id) || MembersList?.length === 0) {
                  setIsLoader(true)
                  let MemberList = MembersList
                  MemberList.push(patientData)
                  setMembersList(MemberList)
                  if (MemberList?.length === 1) {
                    setPrimaryPatientId(patientData?.patient_id)
                  }
                  setTimeout(() => { setIsLoader(false) }, 1000)
                } else {
                  errorMessage('Patient Already Added !')
                }
              }
              if (list?.length > 1) {
                setPatientSearchList(list);
              }
            } else {
              errorMessage("No Records Found !");
            }
          }
        }).catch((error) => {
          LoaderFunction(false);
          if (error?.response?.data?.message) {
            errorMessage(error.response.data.message);
          } else {
            errorMessage(error.message);
          }
        });
    } catch (error) {
      errorMessage(error.message);
    }
  };

  const handleCheckBox = (e, key) => {
    try {
      let checked = e.target.checked
      setPayments((prev) => ({
        ...prev,
        [key]: checked,
        cash_amt: key === "isCash" && !checked ? '' : prev.cash_amt,
        card_amt: key === "isCard" && !checked ? '' : prev.card_amt,
        upi_amt: key === "isUPI" && !checked ? '' : prev.upi_amt,
        bank_amt: key === "isBank" && !checked ? '' : prev.bank_amt,
        cheque_amt: key === "isCheque" && !checked ? '' : prev.cheque_amt,
        card_no: key === "isCard" && !checked ? '' : prev.card_no,
        bank_no: key === "isBank" && !checked ? '' : prev.bank_no,
        cheque_no: key === "isCheque" && !checked ? '' : prev.cheque_no,
        upi_no: key === "isUPI" && !checked ? '' : prev.upi_no
      }))
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const cashTextBox = (key, values, label, Icon) => {
    return (
      <TextField
        size='small'
        sx={{ width: '10dvw', mt: '0.5rem', ml: "0.5dvw" }}
        value={values}
        label={`${label} (${CurrencySymbol})`}
        onChange={(e) => onChangeHandler(e, key)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <img src={Icon} alt={label} className='eMed_action_img_small' />
            </InputAdornment>
          ),
        }}
      />
    )
  }

  const onChangeHandler = (e, key) => {
    try {
      let value = e.target.value
      setPayments((prev) => {
        switch (key) {
          case 'cash_amt':
          case 'card_amt':
          case 'upi_amt':
          case 'bank_amt':
          case 'cheque_amt':
            if ((CommonValidation.numberOnly(value) && +value <= +selectedPackage?.package_amount) || value === '') {
              return { ...prev, [key]: value }
            } else {
              return { ...prev }
            }
          default:
            return { ...prev, [key]: value }
        }
      })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const referenceTextBox = (key, values) => {
    return (
      <TextField
        size='small'
        sx={{ width: '13dvw', mt: '0.5rem', ml: '0.5rem' }}
        value={values}
        label={'Reference Number'}
        onChange={(e) => onChangeHandler(e, key)}
        InputProps={{ emed_tid: key }}
      />
    )
  }

  const showCashTextBox = () => {
    return (
      <Box component={'div'}>
        <Box component={'div'}>
          <FormControlLabel control={<Checkbox size='small' checked={payments?.isCash} onChange={(e) => handleCheckBox(e, 'isCash')} />} label={<Typography>Cash</Typography>} />
          <FormControlLabel control={<Checkbox size='small' checked={payments?.isCard} onChange={(e) => handleCheckBox(e, 'isCard')} />} label={<Typography>Card</Typography>} />
          <FormControlLabel control={<Checkbox size='small' checked={payments?.isUPI} onChange={(e) => handleCheckBox(e, 'isUPI')} />} label={<Typography>UPI</Typography>} />
          <FormControlLabel control={<Checkbox size='small' checked={payments?.isBank} onChange={(e) => handleCheckBox(e, 'isBank')} />} label={<Typography>Bank</Typography>} />
          <FormControlLabel control={<Checkbox size='small' checked={payments?.isCheque} onChange={(e) => handleCheckBox(e, 'isCheque')} />} label={<Typography>Cheque</Typography>} />
        </Box>
        <Box component={'div'} sx={{ display: 'flex', flexDirection: "row", overflow: 'auto' }}>
          {payments?.isCash ?
            <Box component={'div'} display={'flex'}>
              {cashTextBox('cash_amt', payments?.cash_amt, 'Cash Amount', ImagePaths.CashIcon.default)}
            </Box> : null}
          {payments?.isCard ?
            <Box component={'div'} display={'flex'}>
              {cashTextBox('card_amt', payments?.card_amt, 'Card Amount', ImagePaths.CardIcon.default)}
              {referenceTextBox('card_no', payments?.card_no)}
            </Box> : null}
          {payments?.isUPI ?
            <Box component={'div'} display={'flex'}>
              {cashTextBox('upi_amt', payments?.upi_amt, 'UPI Amount', ImagePaths.UPIIcon.default)}
              {referenceTextBox('upi_no', payments?.upi_no)}
            </Box> : null}
          {payments?.isBank ?
            <Box component={'div'} display={'flex'}>
              {cashTextBox('bank_amt', payments?.bank_amt, 'Bank Amount', ImagePaths.BankTransferIcon.default)}
              {referenceTextBox('bank_no', payments?.bank_no)}
            </Box> : null}
          {payments?.isCheque ?
            <Box component={'div'} display={'flex'}>
              {cashTextBox('cheque_amt', payments?.cheque_amt, 'Cheque Amount', ImagePaths.ChequeIcon.default)}
              {referenceTextBox('cheque_no', payments?.cheque_no)}
            </Box> : null}
        </Box>
      </Box>
    )
  }

  const PatientSelectionPopup = () => {
    return (
      <Modal open={PatientSearchList?.length > 0}>
        <Box className="eMed_MobileNum_Main" width={"31.5vw"}>
          <Box component={'div'} className="eMed_MobileNum_Header">
            <Typography variant='h6'>{"Patient List"}</Typography>
            <IconButton onClick={() => setPatientSearchList([])} marginRight={'4vw'}>
              <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
            </IconButton>
          </Box>
          <Box component={'div'} className="eMed_MobileNum_wrapper" width={"31vw"}>
            {PatientSearchList?.length > 0 && PatientSearchList.map((list) => {
              let patientFullName = `${list.first_name} ${list.last_name}`;
              const patientData = {
                ...list,
                patient_name: patientFullName,
                patient_mobile_number: list.mobile_number,
                patient_photo_url: list.photo_url
              };

              return (
                <Box key={list.patient_account_number}>
                  <Box className="eMed_Patient_Num_Search_pop" sx={{ width: "30vw" }}>
                    <CommonPatientDetails data={patientData} hideInsurance={true} />
                    <Button
                      size='small'
                      variant='contained'
                      sx={{ textTransform: 'capitalize' }}
                      onClick={() => {
                        setPatientSearchList([]);
                        if ((MembersList?.every((member) => member?.patient_id !== patientData?.patient_id)) || MembersList?.length === 0) {
                          let MemberList = MembersList
                          MemberList.push(patientData)
                          setIsLoader(true)
                          setMembersList(MemberList)
                          if (MemberList?.length === 1) {
                            setPrimaryPatientId(patientData?.patient_id)
                          }
                          setTimeout(() => { setIsLoader(false) }, 1000)
                        } else {
                          errorMessage('Patient Already Added !')
                        }
                      }}
                    >
                      Add Member
                    </Button>
                  </Box>
                  <Divider />
                </Box>
              );
            })}
          </Box>
        </Box>
      </Modal>
    );
  };

  const printMemeberCard = () => {
    try {
      setIsLoader(true)
      RestAPIService.getAllPrint(Serviceurls.MEMBERSHIP_MEMBER_CARD_PRINT + `?summary_id=${MemberSummaryId}`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          setMembershipNumber("")
          setMembersummaryId(null)
          setMemberReceiptId(null)
          setIsLoader(false)
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const printReceiptPrint = () => {
    try {
      setIsLoader(true)
      RestAPIService.getAllPrint(Serviceurls.NEW_RECEIPT_INDIV_PRINT + `?module_type=MEMBERSHIP&receipt_id=${MemberReceiptId}&is_membership_receipt=true`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          setMembershipNumber("")
          setMembersummaryId(null)
          setMemberReceiptId(null)
          setIsLoader(false)
        }).catch((error) => {
          errorMessage(error?.response?.data?.message || error?.message)
        })
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const postmemberShipData = () => {
    try {
      let data = {}
      let payment = []
      if (payments.isCash) {
        payment.push(1)
      }
      if (payments.isCard) {
        payment.push(2)
      }
      if (payments.isUPI) {
        payment.push(3)
      }
      if (payments.isCheque) {
        payment.push(4)
      }
      if (payments.isBank) {
        payment.push(5)
      }
      if (isCardEdit) {
        data = {
          'membership_id': selectedPackage?.id || null,
          'summary_id': location.states?.PackageData?.membership_card_id || null,
          'primary_patient_id': primaryPatientId || null,
          'patient_details': MembersList?.map((list) => (list?.patient_id)),
          'deleted_ids': DeletedIds,
        }
      } else {
        data = {
          'membership_id': selectedPackage?.id || null,
          'primary_patient_id': primaryPatientId || null,
          'patient_details': MembersList?.map((list) => (list?.patient_id)),
          'received_amount': ((+payments?.cash_amt || 0) + (+payments?.card_amt || 0) + (+payments?.upi_amt || 0) + (+payments?.bank_amt || 0) + (+payments?.cheque_amt || 0)),
          'cash_amount': (+payments?.cash_amt || 0),
          'card_amount': (+payments?.card_amt || 0),
          'upi_amount': (+payments?.upi_amt || 0),
          'bank_amount': (+payments?.bank_amt || 0),
          'cheque_amount': (+payments?.cheque_amt || 0),
          'card_ref_no': (payments?.card_no || ''),
          'upi_ref_no': (payments?.upi_no || ''),
          'bank_ref_no': (payments?.bank_no || ''),
          'cheque_ref_no': (payments?.cheque_no || ''),
          "payment_mode": payment,
        }
      }

      RestAPIService.create(data, Serviceurls.MEMBERSHIP_MEMBER_ADD)
        .then((response) => {
          if (response.data.status === 'success') {
            successMessage(response.data.message)
            setMembersList([])
            setSelectedPackage(null)
            setPrimaryPatientId(null)
            setUhidOrPhNumber("")
            if (response.data?.membership_card_number) {
              setMembershipNumber(response.data?.membership_card_number)
            }
            if (isCardEdit) {
              setCachevalue(false, "DisableAllActions")
              history.push({ pathname: '/FOReports/PatientReport/MembershipReport', states: {} })
            } else {
              setMembersummaryId(response.data?.data?.membership_card_id)
              setMemberReceiptId(response.data?.data?.membership_receipt_id)
            }
            setPayments({
              isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
              cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
              upi_no: '', cheque_amt: '', cheque_no: '',
            })
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    }
    catch (e) {
      errorMessage(e.message)
    }
  }

  const renderMembercardNumber = () => {
    return (
      <div>
        <Modal
          open={MembershipNumber !== ""}
        >
          <Box component={'div'} className="eMed_Bill_Success_Preview_Main" height={'19vw'} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <img className="eMed_Bill_Success_animation" src={ImagePaths.SuccessAnimationGif.default} />
            <Typography fontWeight={600}>{'Membership Created Successfully !'}</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '1vw' }}>
              <Typography>Membership Card No</Typography>
              <Typography fontWeight={600} fontSize={'1.3vw'}>{MembershipNumber}</Typography>
            </Box>
            <Box display={'flex'} width={'100%'} justifyContent={'center'} padding={'0.7vw'}>
              <Button sx={{ textTransform: 'capitalize', width: '7vw' }} size="small" variant="outlined" onClick={() => { setMembershipNumber("") }}>{"Close"}</Button>
              <Button sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: "1vw" }} disabled={isLoader} size="small" variant="contained" onClick={() => { printMemeberCard("") }}>{"Print Card"}</Button>
              <Button sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: "1vw" }} disabled={isLoader} size="small" variant="contained" onClick={() => { printReceiptPrint("") }}>{"Receipt Print"}</Button>
            </Box>
          </Box>
        </Modal>
      </div>
    )
  }

  const checkTransationMandatory = () => {
    let hasAccess = JSON.parse(localGetItem('is_transaction_number_mandatory')) ?? JSON.parse(localGetItem('loggedInUserInfo'))?.is_transaction_number_mandatory
    return hasAccess
  }

  return (
    <Box sx={{ p: "0.5dvw", bgcolor: "#fff", fontFamily: "Roboto" }}>
      {/* Top Section */}
      <Paper sx={{ p: "0.5dvw", mb: "2dvh" }} variant="outlined">
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          {/* Left: Membership Plan */}
          <Box sx={{ pr: "2dvw" }}>
            <Typography sx={{ fontSize: "1dvw", fontWeight: 600, color: "#333", mb: "1dvh" }}>
              Membership Plan
            </Typography>
            <Box display="flex" gap="1dvw" flexDirection={"column"}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "1dvw" }}>
                <Autocomplete
                  clearIcon
                  size='small'
                  sx={{ width: "20vw" }}
                  disabled={!props?.Access?.editAccess || isCardEdit}
                  options={packageList || []}
                  getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.package_name}
                  value={selectedPackage || null}
                  onChange={(e, value) => {
                    setSelectedPackage(value);
                    if (value === null) {
                      setMembersList([])
                      setSelectedPackage(null)
                      setUhidOrPhNumber("")
                      setPrimaryPatientId(null)
                      setPayments({
                        isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
                        cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
                        upi_no: '', cheque_amt: '', cheque_no: '',
                      })
                    }
                  }}
                  renderInput={(params) => <TextField size='small' autoComplete='off' {...params} label={"Select Package"} />}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <TextField
                  size='small'
                  label={"UHID / Ph No"}
                  sx={{ width: '20vw', marginRight: "0.5vw" }}
                  id="icd-cde"
                  disabled={(selectedPackage ? false : true) || (MembersList?.length === (selectedPackage?.no_of_members || 0) && selectedPackage?.no_of_members)}
                  placeholder='Search by UHID / Ph No'
                  inputProps={{ maxLength: 20, emed_tid: "UhidorphNumber" }}
                  variant="outlined"
                  value={UhidOrPhNumber}
                  onChange={(event) => setUhidOrPhNumber(event.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && e.target.value !== '' && e.target.value?.length > 4) {
                      getPatientDataSearch(UhidOrPhNumber)
                    }
                  }}
                />
                <Button
                  variant="contained"
                  size="small"
                  sx={{ textTransform: 'capitalize', }}
                  disabled={UhidOrPhNumber === '' || UhidOrPhNumber?.length < 4 || !selectedPackage || (MembersList?.length === (selectedPackage?.no_of_members || 0) && selectedPackage?.no_of_members)}
                  onClick={() => {
                    getPatientDataSearch(UhidOrPhNumber)
                  }}
                >
                  Add
                </Button>
              </Box>
            </Box>
          </Box>

          {/* Right: Membership Details */}
          <Box
            sx={{
              border: "0.1dvw solid #ddd",
              borderRadius: "0.5dvw",
              p: "0.5dvw",
              width: "50dvw",
              bgcolor: "#fafafa",
              height: "17dvh"
            }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center" mb="1dvh" visibility={selectedPackage ? "visible" : "hidden"}>
              <Typography sx={{ fontSize: "1dvw", fontWeight: 600, color: "#333" }}>
                {`Membership Details ${isCardEdit && location?.states?.PackageData?.card_number ? ` -  Card Number : ${location?.states?.PackageData?.card_number}` : ""}`}
              </Typography>
              <Tooltip title={
                <div>
                  {selectedPackage?.percentages?.map((list) => (
                    <li>{list}</li>
                  ))}
                </div>
              } arrow placement="bottom">
                <Typography sx={{ fontSize: "1dvw", fontWeight: 600, color: Colors.ThemeColor }}>View Discount Details</Typography>
              </Tooltip>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row", gridColumn: "span 2", justifyContent: "space-between", alignItems: "center" }} visibility={selectedPackage ? "visible" : "hidden"}>
              <Box sx={{ display: "flex", flexDirection: "column", gridColumn: "span 2", width: "15dvw" }}>
                <Typography sx={{ fontSize: "1dvw", fontWeight: 500, color: "#555" }}>
                  Package Name
                </Typography>
                <Typography sx={{ fontSize: "1dvw", fontWeight: 600, color: "#000" }}>
                  {ContentInTooltip(selectedPackage?.package_name || "-", 50, "1dvw", 600)}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", gridColumn: "span 2" }}>
                <Typography sx={{ fontSize: "1dvw", fontWeight: 500, color: "#555" }}>
                  Package Amount
                </Typography>
                <Typography sx={{ fontSize: "1dvw", fontWeight: 600, color: "#000" }}>
                  {AmountFormat(selectedPackage?.package_amount || "-")}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", gridColumn: "span 2" }}>
                <Typography sx={{ fontSize: "1dvw", fontWeight: 500, color: ((MembersList?.length === (selectedPackage?.no_of_members || 0) && selectedPackage?.no_of_members) ? Colors?.red : "#555") }}>
                  No of Members
                </Typography>
                <Typography sx={{ fontSize: "1dvw", fontWeight: 600, color: ((MembersList?.length === (selectedPackage?.no_of_members || 0) && selectedPackage?.no_of_members) ? Colors?.red : "#000") }}>
                  {`${MembersList?.length} / ${selectedPackage?.no_of_members || 0}`}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", gridColumn: "span 2" }}>
                <Typography sx={{ fontSize: "1dvw", fontWeight: 500, color: "#555" }}>
                  No of Revisits
                </Typography>
                <Typography sx={{ fontSize: "1dvw", fontWeight: 600, color: "#000" }}>
                  {selectedPackage?.no_of_revisits || 0}
                </Typography>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", gridColumn: "span 2" }}>
                <Typography sx={{ fontSize: "1dvw", fontWeight: 500, color: "#555" }}>
                  Period
                </Typography>
                <Typography sx={{ fontSize: "1dvw", fontWeight: 600, color: "#000" }}>
                  {selectedPackage?.duration_str || "-"}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>

      <Paper variant="outlined" sx={{ height: "28dvh", overflowY: "auto" }}>
        <Table size="small" stickyHeader>
          <TableHead >
            <TableRow sx={{ backgroundColor: "#f8f8f8" }}>
              {['S No', "Patient Name", "Mobile No", "UHID", "Age", "Primary Patient", "Action"].map((col) => (
                <TableCell className='eMed_Pharma_tbl_header' key={col} sx={{ fontSize: "1dvw", fontWeight: 600, color: "#333" }}>
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {MembersList?.length ? MembersList.map((row, i) => (
              <TableRow key={i}>
                <TableCell>
                  {`${i + 1}.` || "-"}
                </TableCell>
                <TableCell sx={{ fontSize: "1.1dvw" }}>{row?.patient_name || "-"}</TableCell>
                <TableCell sx={{ fontSize: "1.1dvw" }}>{row?.patient_mobile_number || "-"}</TableCell>
                <TableCell sx={{ fontSize: "1.1dvw" }}>{row?.patient_account_number || row?.patient_uhid || "-"}</TableCell>
                <TableCell sx={{ fontSize: "1.1dvw" }}>{`${row?.age || row?.patient_age || "-"} / ${(row?.gender)?.toUpperCase() || row?.patient_gender?.toUpperCase() || "-"}`}</TableCell>
                <TableCell sx={{ fontSize: "1.1dvw" }}>
                  <Box>
                    <Radio
                      size="small"
                      checked={primaryPatientId === row?.patient_id}
                      onChange={() => setPrimaryPatientId(row?.patient_id)}
                      value={i}
                      name="primary-patient-radio"
                      inputProps={{ 'aria-label': 'Primary Patient' }}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center" gap="0.5dvw">
                    <IconButton size="small" color="error" onClick={() => {
                      if (isCardEdit) {
                        setDeletedIds((prev) => [...prev, row?.patient_id])
                      }
                      let MemberList = MembersList?.filter((member) => member?.patient_id !== row?.patient_id)
                      setMembersList(MemberList)
                      if (primaryPatientId === row?.patient_id) {
                        setPrimaryPatientId(MemberList?.length ? (MemberList?.[0]?.patient_id) : null)
                      }
                    }}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            )) :
              <TableRow>
                <TableCell colSpan={5} align='center'
                  sx={{ borderBottom: 'none' }}
                >No Records To Be Shown</TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </Paper>
      <Paper sx={{ p: "0.5dvw", mt: "2dvh", height: "20dvh", visibility: isCardEdit ? "hidden" : "visible" }} variant="outlined">
        <Typography sx={{ fontSize: "1dvw", fontWeight: 600, color: "#333", mb: "1dvh" }}>
          Select Payment Type
        </Typography>
        {showCashTextBox()}
      </Paper>

      {/* Footer Buttons */}
      <Box display="flex" justifyContent="flex-end" gap="2dvw" mt="2dvh">
        {isCardEdit ?
          <Button
            variant="outlined"
            sx={{ textTransform: "capitalize" }}
            size="small"
            onClick={() => { 
              setCachevalue(false, "DisableAllActions")
              history.push({ pathname: '/FOReports/PatientReport/MembershipReport', states: {} })
             }}
          >
            Back to Reports
          </Button> : null}
        <Button
          variant="outlined"
          sx={{ textTransform: "capitalize" }}
          size="small"
          onClick={() => {
            setMembersList([])
            setSelectedPackage(null)
            setUhidOrPhNumber("")
            setPrimaryPatientId(null)
            setIsCardEdit(false)
            setPayments({
              isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
              cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
              upi_no: '', cheque_amt: '', cheque_no: '',
            })
          }}
        >
          Clear
        </Button>
        <Button
          variant="contained"
          sx={{ textTransform: "capitalize" }}
          size="small"
          onClick={() => {
            setIsLoader(true)
            if (checkTransationMandatory() &&
              ((payments.card_amt !== "" && payments.card_no === "") ||
                (payments.upi_amt !== "" && payments.upi_no === "") ||
                (payments.cheque_amt !== "" && payments.cheque_no === "") ||
                (payments.bank_amt !== "" && payments.bank_no === ""))) {
              errorMessage('Please,Enter Reference Number')
            } else if (
              (payments.card_no !== "" && payments.card_no?.length < TXN_MSG_MAX_LEN) ||
              (payments.upi_no !== "" && payments.upi_no?.length < TXN_MSG_MAX_LEN) ||
              (payments.cheque_no !== "" && payments.cheque_no?.length < TXN_MSG_MAX_LEN) ||
              (payments.bank_no !== "" && payments.bank_no?.length < TXN_MSG_MAX_LEN)) {
              errorMessage(TXN_MSG_MAX)
            } else {
              postmemberShipData()
            }
          }}
          disabled={
            isLoader ||
            !props?.Access?.editAccess ||
            MembersList?.length === 0 ||
            !selectedPackage ||
            !primaryPatientId ||
            (payments?.isCash && !+payments?.cash_amt && !isCardEdit) ||
            (payments?.isCard && !+payments?.card_amt && !isCardEdit) ||
            (payments?.isUPI && !+payments?.upi_amt && !isCardEdit) ||
            (payments?.isBank && !+payments?.bank_amt && !isCardEdit) ||
            (payments?.isCheque && !payments?.cheque_amt && !isCardEdit) ||
            (((+payments?.cash_amt || 0) + (+payments?.card_amt || 0) + (+payments?.upi_amt || 0) + (+payments?.bank_amt || 0) + (+payments?.cheque_amt || 0)) !== (+selectedPackage?.package_amount || 0) && +selectedPackage?.package_amount && !isCardEdit)}
        >
          {isCardEdit ? "Save" : 'Receive Payment'}
        </Button>
      </Box>
      {isErrorMsg ?
        <ToastMsg
          severity={'error'}
          msg={isErrorMsgText}
          msgPop={() => setIsErrorMsg(false)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={() => setSuccessMsg(false)}
        />
        : null}
      <Loader loaderOpen={isLoader} />
      {PatientSelectionPopup()}
      {renderMembercardNumber()}
    </Box>
  );
};

export default MembershipPayment;
